import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";

function SelectorDePrecios({
  productos,
  sucursales,
  sucursalesSeleccionadas,
  setSucursalesSeleccionadas,
  productosSeleccionados,
  setProductosSeleccionados,
}) {
  const [todasSucursales, setTodasSucursales] = useState(true);
  const [todosProductos, setTodosProductos] = useState(true);

  const [sucursalInput, setSucursalInput] = useState("");
  const [productoInput, setProductoInput] = useState("");
  const [filtroSucursales, setFiltroSucursales] = useState("");
  const [filtroProductos, setFiltroProductos] = useState("");
  // Inicializar con todos los elementos seleccionados
  useEffect(() => {
    setSucursalesSeleccionadas([...sucursales]);
    setProductosSeleccionados([...productos]);
  }, [
    productos,
    sucursales,
    setSucursalesSeleccionadas,
    setProductosSeleccionados,
  ]);

  const handleToggleTodasSucursales = (event) => {
    const checked = event.target.checked;
    setTodasSucursales(checked);
    setSucursalesSeleccionadas(checked ? [...sucursales] : []);
  };

  const handleToggleTodosProductos = (event) => {
    const checked = event.target.checked;
    setTodosProductos(checked);
    setProductosSeleccionados(checked ? [...productos] : []);
  };

  const handleAgregarSucursal = (sucursal) => {
    if (
      sucursal &&
      !sucursalesSeleccionadas.some((s) => s.id === sucursal.id)
    ) {
      setSucursalesSeleccionadas((prev) => [...prev, sucursal]);
      setSucursalInput("");
      // Si se agrega manualmente una sucursal, desmarcar "Todas"
      if (todasSucursales) {
        setTodasSucursales(false);
      }
    }
  };

  const handleAgregarProducto = (producto) => {
    if (
      producto &&
      !productosSeleccionados.some((p) => p.idproducto === producto.idproducto)
    ) {
      setProductosSeleccionados((prev) => [...prev, producto]);
      setProductoInput("");
      // Si se agrega manualmente un producto, desmarcar "Todos"
      if (todosProductos) {
        setTodosProductos(false);
      }
    }
  };

  const eliminarSucursal = (id) => {
    const nuevasSucursales = sucursalesSeleccionadas.filter((s) => s.id !== id);
    setSucursalesSeleccionadas(nuevasSucursales);

    // Si no hay sucursales seleccionadas, marcar "Todas" como false
    if (nuevasSucursales.length === 0) {
      setTodasSucursales(false);
    }

    // Si se eliminó alguna, ya no están todas seleccionadas
    if (todasSucursales) {
      setTodasSucursales(false);
    }
  };

  const eliminarProducto = (id) => {
    const nuevosProductos = productosSeleccionados.filter(
      (p) => p.idproducto !== id,
    );
    setProductosSeleccionados(nuevosProductos);

    // Si no hay productos seleccionados, marcar "Todos" como false
    if (nuevosProductos.length === 0) {
      setTodosProductos(false);
    }

    // Si se eliminó alguno, ya no están todos seleccionados
    if (todosProductos) {
      setTodosProductos(false);
    }
  };

  // Filtros para el autocomplete (mostrar solo los no seleccionados)
  const sucursalesDisponibles = sucursales.filter(
    (s) => !sucursalesSeleccionadas.some((ss) => ss.id === s.id),
  );

  const productosDisponibles = productos.filter(
    (p) => !productosSeleccionados.some((pp) => pp.idproducto === p.idproducto),
  );

  const sucursalesFiltradas = sucursalesSeleccionadas.filter((s) =>
    s.nombre.toLowerCase().includes(filtroSucursales.toLowerCase()),
  );

  // Filtrar productos según el texto de búsqueda
  const productosFiltrados = productosSeleccionados.filter((p) =>
    p.nombre.toLowerCase().includes(filtroProductos.toLowerCase()),
  );

  return (
    <Grid container spacing={1}>
      {/* Sucursales */}
      <Grid item xs={6}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                checked={todasSucursales}
                onChange={handleToggleTodasSucursales}
              />
            }
            label="Todas las Sucursales"
          />
        </Box>
        <Autocomplete
          size="small"
          disabled={todasSucursales}
          options={sucursalesDisponibles}
          getOptionLabel={(s) => s.nombre}
          value={null}
          inputValue={sucursalInput}
          onInputChange={(_, value) => setSucursalInput(value)}
          onChange={(_, value) => handleAgregarSucursal(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Agregar sucursal"
              placeholder="Buscar..."
            />
          )}
        />

        <Box
          mt={1}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            backgroundColor: "#f9f9f9",
            height: 230,
            overflowY: "auto",
          }}
        >
          <Box
            mb={0.5}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontWeight="bold" color="#1F618D">
              Sucursales Seleccionadas:
            </Typography>
            <TextField
              size="small"
              placeholder="Buscar..."
              value={filtroSucursales}
              onChange={(e) => setFiltroSucursales(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              sx={{ width: "50%" }}
            />
          </Box>

          {sucursalesFiltradas.length > 0 ? (
            sucursalesFiltradas.map((s) => (
              <Box
                key={s.id}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderTop={1}
                borderColor="divider"
                pt={1}
                sx={{
                  "&:first-of-type": {
                    borderTop: "none",
                  },
                }}
              >
                <Typography variant="body2">• {s.nombre}</Typography>
                <IconButton size="small" onClick={() => eliminarSucursal(s.id)}>
                  <DeleteIcon fontSize="small" color="error" />
                </IconButton>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              {filtroSucursales
                ? "No hay coincidencias"
                : "No hay sucursales seleccionadas"}
            </Typography>
          )}
        </Box>
      </Grid>

      {/* Productos */}
      <Grid item xs={6}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                checked={todosProductos}
                onChange={handleToggleTodosProductos}
              />
            }
            label="Todos los Productos"
          />
        </Box>
        <Autocomplete
          size="small"
          disabled={todosProductos}
          options={productosDisponibles}
          getOptionLabel={(p) => p.nombre}
          value={null}
          inputValue={productoInput}
          onInputChange={(_, value) => setProductoInput(value)}
          onChange={(_, value) => handleAgregarProducto(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Agregar producto"
              placeholder="Buscar..."
            />
          )}
        />

        <Box
          mt={1}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            backgroundColor: "#f9f9f9",
            height: 230,
            overflowY: "auto",
          }}
        >
          <Box
            mb={0.5}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontWeight="bold" color="#1F618D">
              Productos Seleccionados:
            </Typography>
            <TextField
              size="small"
              placeholder="Buscar..."
              value={filtroProductos}
              onChange={(e) => setFiltroProductos(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              sx={{ width: "50%" }}
            />
          </Box>

          {productosFiltrados.length > 0 ? (
            productosFiltrados.map((p) => (
              <Box
                key={p.idproducto}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderTop={1}
                borderColor="divider"
                pt={1}
                sx={{
                  "&:first-of-type": {
                    borderTop: "none",
                  },
                }}
              >
                <Typography variant="body2">• {p.nombre}</Typography>
                <IconButton
                  size="small"
                  onClick={() => eliminarProducto(p.idproducto)}
                >
                  <DeleteIcon fontSize="small" color="error" />
                </IconButton>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              {filtroProductos
                ? "No hay coincidencias"
                : "No hay productos seleccionados"}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

export default SelectorDePrecios;
